import * as React from "react";

export const IsFilledContext = React.createContext(true);
